var map = {
	"./img/andalucia/teaser_large.webp": 29264,
	"./img/basque-country/teaser_large.webp": 8858,
	"./img/berlin/teaser_large.webp": 96178,
	"./img/copenhagen/teaser_large.webp": 18995,
	"./img/portugal/teaser_large.webp": 31079,
	"./img/slovenia/teaser_large.webp": 12243,
	"./img/turkey/teaser_large.webp": 18007
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67905;